import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'app-eye-off',
  templateUrl: './eye-off.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EyeOffComponent {
  @Input()
  public fillColor: string | undefined;
}
